import React from 'react';

import ExternalLink from 'ui/ExternalLink';
import { withAppContext } from './AppContext';

function BrandLink({ app, name, className, children }) {
    const {
        settings: { brand },
    } = app;
    return (
        <ExternalLink className={className} url={brand[name]}>
            {children}
        </ExternalLink>
    );
}

export default withAppContext(BrandLink);
